import ReactMarkdown from 'react-markdown'
import rehypeRaw from 'rehype-raw';
// import remarkGfm from 'remark-gfm'

const TextPage = ( props : {title : string, body : string}) => {
    
    return  <div className="body-block">
        <h1>{props.title}</h1>
        <ReactMarkdown rehypePlugins={[rehypeRaw]}>{props.body}</ReactMarkdown>
    </div>
}

export default TextPage;